// removed by extract-text-webpack-plugin
module.exports = {"body":"src-components-VerifyEmailAddress-___index__body___1lTsp","subtext":"src-components-VerifyEmailAddress-___index__subtext___3szHg","subtextLink":"src-components-VerifyEmailAddress-___index__subtextLink___3Ncvn","logo":"src-components-VerifyEmailAddress-___index__logo___k9jBK","container":"src-components-VerifyEmailAddress-___index__container___3F8_y","mainText":"src-components-VerifyEmailAddress-___index__mainText___3SaQA","verifyFailed":"src-components-VerifyEmailAddress-___index__verifyFailed___3qu2_","top":"src-components-VerifyEmailAddress-___index__top___37MHf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VerifyEmailAddress/index.css
// module id = 1273
// module chunks = 3